import React from 'react';
import { connect } from 'react-redux';
import {
  BlankSlate,
  Description,
  Heading,
} from 'components/_shared/blank_slate';
import ReactHtml from 'components/shared/ReactHtml';
import { getAskTheExpertToggleTranslations } from 'selectors/learn/meta';
import { Button } from 'ui';
import LearnExpertIcon from '../../Search/Results/LearnExpertIcon';
import AskTheExpertToggle from '../../shared/AskTheExpertToggle';

const NoContent = ({ i18n }) => (
  <BlankSlate fullWidth align="left" borderStyle="dashed">
    <Heading>{i18n.no_content.heading}</Heading>
    <AskTheExpertToggle i18n={i18n.expertToggle}>
      {({ toggleModal }) => (
        <div className="LearnAskTheExpert">
          <Description>
            <ReactHtml>{i18n.no_content.body_html}</ReactHtml>
          </Description>
          <Button className="mt-16" customColor tall onClick={toggleModal}>
            <LearnExpertIcon />
            {i18n.expert.action_button}
          </Button>
        </div>
      )}
    </AskTheExpertToggle>
  </BlankSlate>
);

const mapStateToProps = state => ({
  i18n: {
    expert: state.meta.i18n.learn.expert,
    no_content: state.meta.i18n.learn.no_content,
    expertToggle: getAskTheExpertToggleTranslations(state),
  },
});

export default connect(mapStateToProps)(NoContent);
